import GameObject from '../../../GameObject/GameObject';
import { Point } from 'pixi.js';
import Sprite from '../../../Prototype/Sprite';
import AnimationClip from '../AnimationClip';
import {
    createScaleTween,
    getTweenProps,
    createPositionTween,
    createAlphaTween,
} from '../AnimationTweenHelper';
import { Easing, Tween } from '@tweenjs/tween.js';
import { AwaitIterators } from '../AnimationHelper';

export class TNTExplosionEffect extends AnimationClip {
    *execute() {
        const blast = GameObject.Instantiate(Sprite, {
            texture: 'blast',
            anchor: new Point(0.5, 0.5),
            scale: new Point(0.3, 0.3),
        });

        const halo = GameObject.Instantiate(Sprite, {
            texture: 'halo',
            anchor: new Point(0.5, 0.5),
        });

        const dusts: GameObject[] = [];
        for (let i = 0; i < 5; i++) {
            const dust = GameObject.Instantiate(Sprite, {
                texture: 'dust',
                anchor: new Point(0.5, 0.5),
                rotation: Math.random() * i,
            });
            dusts.push(dust);
            this.gameObject.addChild(dust);
        }

        blast.addChild(halo);
        this.gameObject.addChild(blast);

        const tweenScale = createScaleTween({
            ...getTweenProps(blast, this, new Point(1.5, 1.5)),
            duration: 500,
        });

        const tweenAlpha = createAlphaTween({
            ...getTweenProps(blast, this, { alpha: 0 }),
            duration: 500,
            delay: 300,
        });

        yield* AwaitIterators([
            this.startTween(tweenScale),
            this.startTween(tweenAlpha),
            this.dustEffect(dusts),
        ]);
        this.gameObject.destroy();
    }

    *dustEffect(dusts: GameObject[]) {
        const tweens: Tween[] = [];
        const nDust = 5;
        const step = (2 * Math.PI) / nDust;

        dusts.forEach((dust, i) => {
            const scaleTween = createScaleTween({
                ...getTweenProps(dust, this, new Point(0.5, 0.5)),
                duration: 900,
                easing: Easing.Quadratic.Out,
            });

            const positionTween = createPositionTween({
                ...getTweenProps(
                    dust,
                    this,
                    new Point(
                        Math.cos(i * step) * 100,
                        Math.sin(i * step) * 100
                    )
                ),
                duration: 400,
                easing: Easing.Quadratic.Out,
            });

            const alphaTween = createAlphaTween({
                ...getTweenProps(dust, this, { alpha: 0 }),
                duration: 500,
                delay: 400,
            });

            tweens.push(...[alphaTween, positionTween, scaleTween]);
        });

        yield* AwaitIterators(tweens.map(tween => this.startTween(tween)));
    }
}
